import React, { useContext, useEffect, useRef, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import ExternalTicketTransferModal from "../ExternalTicketTransferModal";
import TagSelectModal from "../TagSelectModal"; // Importe o modal criado
import toastError from "../../errors/toastError";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl }) => {
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
    const [externalTransferModalOpen, setExternalTransferModalOpen] = useState(false);
    const [tagModalOpen, setTagModalOpen] = useState(false); // Novo estado
    const isMounted = useRef(true);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleHistoryMessage = async () => {
        handleClose();

        try {
            await api.post(`/messages-history/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    };

    const handleMarkAsUnread = async () => {
        handleClose();

        try {
            await api.patch(`/tickets/${ticket.id}/unread`);
        } catch (err) {
            toastError(err);
        }
    };

    const handleDeleteTicket = async () => {
        try {
            await api.delete(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    };

    const handleOpenConfirmationModal = e => {
        setConfirmationOpen(true);
        handleClose();
    };

    const handleOpenTransferModal = e => {
        setTransferTicketModalOpen(true);
        handleClose();
    };

    const handleOpenExternalTransferModal = e => {
        setExternalTransferModalOpen(true);
        handleClose();
    };

    const handleOpenTagModal = e => {
        setTagModalOpen(true);
        handleClose();
    };

    const handleCloseTransferTicketModal = () => {
        if (isMounted.current) {
            setTransferTicketModalOpen(false);
        }
    };

    return (
        <>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={menuOpen}
                onClose={handleClose}
            >
                <MenuItem onClick={handleOpenTransferModal}>
                    {i18n.t("ticketOptionsMenu.transfer")}
                </MenuItem>

                <MenuItem onClick={handleOpenExternalTransferModal}>
                    Transferir para plataforma externa
                </MenuItem>
                
                <MenuItem onClick={handleOpenTagModal}>
                    Etiquetas
                </MenuItem>

                <MenuItem onClick={handleMarkAsUnread}>
                    {i18n.t("ticketOptionsMenu.markAsUnread")}
                </MenuItem>

                <MenuItem onClick={handleHistoryMessage}>
                    {i18n.t("ticketOptionsMenu.history")}
                </MenuItem>
                <Can
                    role={user.profile}
                    perform="ticket-options:deleteTicket"
                    yes={() => (
                        <MenuItem onClick={handleOpenConfirmationModal}>
                            {i18n.t("ticketOptionsMenu.delete")}
                        </MenuItem>
                    )}
                />
            </Menu>
            
            <ConfirmationModal
                title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}: #${ticket.id}`}
                open={confirmationOpen}
                onClose={setConfirmationOpen}
                onConfirm={handleDeleteTicket}
            >
                {i18n.t("ticketOptionsMenu.confirmationModal.message")}
            </ConfirmationModal>
            
            <TransferTicketModal
                modalOpen={transferTicketModalOpen}
                onClose={handleCloseTransferTicketModal}
                ticketid={ticket.id}
                ticketWhatsappId={ticket.whatsappId}
            />

            <ExternalTicketTransferModal
                open={externalTransferModalOpen}
                onClose={() => setExternalTransferModalOpen(false)}
                ticketId={ticket.id}
            />

            <TagSelectModal
                open={tagModalOpen}
                onClose={() => setTagModalOpen(false)}
                ticketId={ticket.id}
            />
        </>
    );
};

export default TicketOptionsMenu;
